export var ArticleResolution;
(function (ArticleResolution) {
    ArticleResolution[ArticleResolution["COLLECTING_VOTES"] = 110] = "COLLECTING_VOTES";
    ArticleResolution[ArticleResolution["IN_DEVELOPMENT"] = 112] = "IN_DEVELOPMENT";
    ArticleResolution[ArticleResolution["COMING_SOON"] = 114] = "COMING_SOON";
    ArticleResolution[ArticleResolution["RELEASED"] = 116] = "RELEASED";
    ArticleResolution[ArticleResolution["INVESTIGATING"] = 120] = "INVESTIGATING";
    ArticleResolution[ArticleResolution["WORKING_ON_IT"] = 122] = "WORKING_ON_IT";
    ArticleResolution[ArticleResolution["RESOLVED"] = 124] = "RESOLVED";
    ArticleResolution[ArticleResolution["THIRD_PARTY_BUG"] = 126] = "THIRD_PARTY_BUG";
})(ArticleResolution || (ArticleResolution = {}));
//# sourceMappingURL=article-resolution.enum.js.map